import React from "react";
import intl from "react-intl-universal";
import { TableRow, TableCell, IconButton } from "@material-ui/core";
import {
  DeleteForever as DeleteIcon,
  Edit as EditIcon,
  Map as MapIcon,
} from "@material-ui/icons";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { EVENT_I18N_TAGS, POSSESSION_I18N_TAGS } from "../constants";
import { IListItemProps } from "./types";

const useStyles = makeStyles(({ brand }: Theme) => ({
  successListItem: {
    background: brand.grassGreen[60],
  },
  failedListItem: {
    background: brand.redRosesRed[60],
  },
}));

export const ListItem = React.memo(
  ({
    data,
    playerRecord,
    onMouseEnter,
    onMouseLeave,
    onDelete,
    onEdit,
    isHomeTeam,
  }: IListItemProps) => {
    const classes = useStyles();
    const handleMouseEnter = (event: any) => {
      onMouseEnter(data, {
        x: event.pageX,
        y: event.pageY,
      });
    };
    const handleDeleteClick = () => {
      onDelete(data);
    };

    const handleEditClick = () => {
      onEdit(data);
    };

    return (
      <TableRow
        key={data.id}
        className={
          data.succeed ? classes.successListItem : classes.failedListItem
        }
      >
        <TableCell>
          {intl.get(
            isHomeTeam ? "STAT_FORM_LABEL_HOME" : "STAT_FORM_LABEL_AWAY"
          )}
        </TableCell>
        <TableCell>{intl.get(EVENT_I18N_TAGS[data.action])}</TableCell>
        <TableCell>{playerRecord[data.fromPlayer]?.name || "-"}</TableCell>
        <TableCell>{playerRecord[data.toPlayer]?.name || "-"}</TableCell>
        <TableCell>{intl.get(POSSESSION_I18N_TAGS[data.possession])}</TableCell>
        <TableCell>
          {intl.get(
            data.succeed ? "STAT_RESULT_SUCCESS" : "STAT_RESULT_FAILED"
          )}
        </TableCell>
        <TableCell>
          <IconButton
            onMouseEnter={handleMouseEnter}
            onMouseLeave={onMouseLeave}
            size="small"
          >
            <MapIcon fontSize="small" />
          </IconButton>
        </TableCell>
        <TableCell>
          {new Date(data.created_at * 1000).toISOString().slice(11, 19)}
        </TableCell>
        <TableCell>
          <IconButton size="small" onClick={handleEditClick}>
            <EditIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={handleDeleteClick}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  }
);
